interface BudgetBarProps {
  needInches: number
  haveInches: number
  label: string
}

export default function BudgetBar({ needInches, haveInches, label }: BudgetBarProps) {
  const ok = needInches <= haveInches
  const pct = Math.min(100, (haveInches / Math.max(needInches, 1)) * 100)
  // aria-valuemax must be >= aria-valuenow; when fabric is OK the have exceeds need.
  const ariaMax = Math.round(Math.max(needInches, haveInches) * 10) / 10
  const haveRounded = Math.round(haveInches * 10) / 10
  const needRounded = Math.round(needInches * 10) / 10
  const ariaLabel = `${label}: ${haveRounded}" available, ${needRounded}" needed — ${ok ? "OK" : "short"}`
  return (
    <div className="flex items-center gap-2 w-full">
      <div className="flex-1 h-1.5 rounded-full bg-muted overflow-hidden">
        <div
          role="meter"
          aria-label={ariaLabel}
          aria-valuenow={haveRounded}
          aria-valuemin={0}
          aria-valuemax={ariaMax}
          className={`h-full rounded-full transition-[width,background-color] duration-500 ${ok ? "bg-success" : "bg-destructive"}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className={`tabular-nums shrink-0 ${ok ? "text-success" : "text-destructive"}`}>
        {ok ? "OK" : "short"}
      </span>
    </div>
  )
}
